import React, { useEffect } from "react";
import { getPlanilla, resetPlanillasFlag } from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useParams } from "react-router-dom";

// Importaciones de reacciones
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Alert,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Editar from "./Editar";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const PlanillaEstrategicaEditar = () => {
  // Obtiene el ID desde la URL
  const { id } = useParams();
  const dispatch = useDispatch();
  const perfil = DatosSesion("perfil");

  useEffect(() => {
    dispatch(getPlanilla(id));
  }, [dispatch, id]);

  const selectLayoutState = (state) => state;
  const pageData = createSelector(selectLayoutState, (state) => ({
    planilla: state.PlanillaEstrategica.planilla,
    error: state.PlanillaEstrategica.error,
    loading: state.PlanillaEstrategica.loading,
    errorMsg: state.PlanillaEstrategica.errorMsg,
    colorMsg: state.PlanillaEstrategica.colorMsg,
    exito: state.PlanillaEstrategica.exito,
  }));

  // Inside your component
  const { planilla, error, loading, errorMsg, colorMsg, exito } =
    useSelector(pageData);
  // Obtener los laboratorios
  const selectLabsState = (state) => state.Laboratorios;
  const labsPageData = createSelector(selectLabsState, (state) => state);
  // Inside your component
  const { laboratorios } = useSelector(labsPageData);
  // Obtener los principios activos
  const selectPrincActState = (state) => state.PrincipiosActivos;
  const princActPageData = createSelector(
    selectPrincActState,
    (state) => state
  );
  // Inside your component
  const { principiosActivos } = useSelector(princActPageData);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetPlanillasFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <BreadCrumb
                title="Editar Planilla Estratégica"
                pageTitle="Listar  Planillas Estratégicas"
                url="/planilla-estrategica"
              />

              <Row>
                <Col lg={12}>
                  <Card>
                    <CardHeader className="border-0">
                      {errorMsg && errorMsg ? (
                        <Alert color={colorMsg}> {error} </Alert>
                      ) : null}
                    </CardHeader>
                    <CardBody>
                      {exito && <Editar planilla={planilla} />}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PlanillaEstrategicaEditar;
